import {StyleSheet} from 'react-native';

import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

import color from './competency.color';

export const bannerColors = {
  [COACH]: StyleSheet.create({
    base: {
      backgroundColor: color[COACH].primaryLightest,
      borderColor: color[COACH].primary,
    },
    icon: {
      color: color[COACH].primary,
    },
  }),
  [BUSINESS_COACH]: StyleSheet.create({
    base: {
      backgroundColor: color[BUSINESS_COACH].primaryLightest,
      borderColor: color[BUSINESS_COACH].primary,
    },
    icon: {
      color: color[BUSINESS_COACH].primary,
    },
  }),
  [BUSINESS_LEADER]: StyleSheet.create({
    base: {
      backgroundColor: color[BUSINESS_LEADER].primaryLightest,
      borderColor: color[BUSINESS_LEADER].primaryLight,
    },
    icon: {
      color: color[BUSINESS_LEADER].primaryLight,
    },
  }),
};
